module.exports = __webpack_public_path__ + "img/fail.e9586575.png";